import { z } from "zod";
import { zStringId, zTimestamps } from "../../utils";
import { zUserSnippet } from "../users";

export const zNote = z.object({
  _id: zStringId(),
  title: z.string(),
  text: z.string(),
  plainText: z.string(),
  userDoc: zUserSnippet,
  tags: z.array(z.string()),
  sharedWithDocs: z.array(zUserSnippet),
  ...zTimestamps(),
});

export type Note = z.infer<typeof zNote>;
